import PaymentMethodFragment from './PaymentMethodFragment';
export default `
  query ListPaymentMethods($filter: JSON, $limit: Int, $offset: Int) {
    listPaymentMethods(filter: $filter, limit: $limit, offset: $offset) {
      size
      total
      items {
        ...PaymentMethodFragment
      }
    }
  }
  ${PaymentMethodFragment}
`;
